import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
	standalone: false,
	selector: 'app-split-change-blocked-modal',
	templateUrl: './split-change-blocked-modal.component.html',
	styleUrls: ['./split-change-blocked-modal.component.scss'],
})
export class SplitChangeBlockedModalComponent {
	private modalCtrl = inject(ModalController);

	static async show(modalCtrl: ModalController): Promise<void> {
		const modal = await modalCtrl.create({
			component: SplitChangeBlockedModalComponent,
			showBackdrop: true,
			backdropDismiss: true,
			cssClass: 'split-change-blocked-sheet',
		});

		await modal.present();
		await modal.onWillDismiss();
	}

	async close() {
		await this.modalCtrl.dismiss();
	}
}
